export const POST_LOGOUT_AMPLIFY_GUARD = 'postLogoutAmplifyGuard';

const GUARD_MS = 8000;

export const markPostLogoutAmplifyGuard = () => {
  sessionStorage.setItem(POST_LOGOUT_AMPLIFY_GUARD, String(Date.now()));
};

export const clearPostLogoutAmplifyGuard = () => {
  sessionStorage.removeItem(POST_LOGOUT_AMPLIFY_GUARD);
};

/** Skip probing Amplify on login mount right after logout (stale federated session). */
export const shouldSkipAmplifyResumeOnLoginMount = () => {
  const guardTs = sessionStorage.getItem(POST_LOGOUT_AMPLIFY_GUARD);
  if (!guardTs) {
    return false;
  }
  const elapsed = Date.now() - Number(guardTs);
  if (elapsed > GUARD_MS) {
    sessionStorage.removeItem(POST_LOGOUT_AMPLIFY_GUARD);
    return false;
  }
  return true;
};

export const hasOAuthTokensInUrl = () => {
  const hash = window.location.hash;
  return hash.includes('access_token=') || hash.includes('id_token=');
};
